/**
 * @license hugeicons-react v0.2.0
 *
 * See the LICENSE file in the root directory of this source tree.
 */

import r from"../create-hugeicon-component.js";const o=r("ArrowUp02Icon",[["path",{d:"M12 4L12 20",stroke:"currentColor",key:"k0"}],["path",{d:"M17 8.99996C17 8.99996 13.3176 4.00001 12 4C10.6824 3.99999 7 9 7 9",stroke:"currentColor",key:"k1"}]]);export{o as default};
